import Lang from "@vendors-fr/messages";
import {getParams, returnMessageFromDialog, shippingCostDisplay} from "@plugins-fr/payment";
import {getCartAjaxUrl, setCartItem} from "@plugins-fr/script";
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {AddPriceFactory, checkAddPriceQuantity, refreshRetailAddPriceQuantity} from "@plugins-fr/retailProductAddPrice";
import {DialogMessage} from "@plugins-fr/dialogMessage";
import {checkoutPageAddPriceItemAddToCart} from "@commons/userTracks/eventActionName";
import {recordUserEventTrack} from "@commons/userTracks/userTrack";

$(function() {
    var JS_VARS = JSON.parse(shops);
    var JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);

    var addPrice = {
        'changeQuantity': function(element) {
            var quantityElem = $(element);
            var qty = quantityElem.val();
            var max = quantityElem.data('max');
            var min = quantityElem.data('min');
            var add_price_standard_id = quantityElem.data('add-price-standard-id');
            // var add_price = $('.js_addprice_quantity[data-add-price-standard-id=' + add_price_standard_id + ']');

            var checkboxElem = quantityElem.closest('li').find('.js_add_cart_addprice[data-add-price-standard-id=' + add_price_standard_id + ']');

            if (qty >= max) {
                qty = max;
                quantityElem.parent().find(".js_qty_plus").prop('disabled', true);
            } else if (Math.sign(qty) == '-1' || parseInt(qty) == '0') {
                qty = min;
                quantityElem.parent().find(".js_qty_minus").prop('disabled', true);
            } else {
                quantityElem.parent().find(".js_qty_plus").prop('disabled', false);
                quantityElem.parent().find(".js_qty_minus").prop('disabled', false);
            }
            quantityElem.val(qty);

            if ( qty != 1 ) {
                quantityElem.parent().find(".js_qty_minus").prop('disabled', false);
            }  else {
                quantityElem.parent().find(".js_qty_minus").prop('disabled', true);
            }

            checkboxElem.prop('checked', true);
            checkboxElem.closest('.js_addproduct_items').addClass('active');

            const addProductItemLabelDom = checkboxElem.closest('.js_addproduct_items > label');
            addProductItemLabelDom.attr('style', addProductItemLabelDom.data('active-style'));

            const checkboxLabelDom = checkboxElem.next('label');
            checkboxLabelDom.attr('style', checkboxLabelDom.data('active-style'));
        },

        // 檢查合併預購出貨月份訂單
        'preOrderMonthValidate': function (addpriceArea, checkboxElem) {
            var result = true;
            var preOrderAddprices = addpriceArea.find('.js_add_cart_addprice[data-is-pre-order=1]:checked');

            if (checkboxElem.data('is-pre-order') === 1 && preOrderAddprices.length > 1) {
                preOrderAddprices.each(function(){
                    var preOrderCheckboxElem = $(this);
                    if (!preOrderCheckboxElem.is(checkboxElem)) {
                        if (preOrderCheckboxElem.data('add-price-period') != checkboxElem.data('add-price-period')) {
                            result = false;
                            returnMessageFromDialog(Lang.get('frontend.errormsg.addPrice.quantity.period'));
                        }
                        return false; //break;
                    }
                });
            }
            return result;
        },

        //  checkbox 勾選，紅框
        'clickCheckbox': function (checkboxElem, isChecked) {
            const addProductItemDom = checkboxElem.closest('.js_addproduct_items');
            const addProductItemLabelDom = checkboxElem.closest('.js_addproduct_items > label');
            const checkboxLabelDom = checkboxElem.next('label');

            checkboxElem.prop('checked', isChecked);

            if (isChecked) {
                addProductItemDom.addClass('active');
                addProductItemLabelDom.attr('style', addProductItemLabelDom.data('active-style'));
                checkboxLabelDom.attr('style', checkboxLabelDom.data('active-style'));
            } else {
                addProductItemDom.removeClass('active');
                addProductItemLabelDom.attr('style', '');
                checkboxLabelDom.attr('style', '');
            }
        },

        'initView': function (existAddprices, addpriceArea, mainProduct) {

            // 已在購物車內的加購品，套用已選擇效果
            if (existAddprices.length > 0) {
                existAddprices.each(function () {
                    var addpriceQty = $(this).data('add-price-qty');
                    var addpriceStandardId = $(this).data('add-price-standard-id');
                    var addpriceQuantityElem = addpriceArea.find('.js_addprice_quantity[data-add-price-standard-id=' + addpriceStandardId + ']');
                    if (addpriceQuantityElem.length > 0) {
                        addpriceQuantityElem.val(addpriceQty);
                        addpriceQuantityElem.trigger('change');
                    }
                });
            }

            // 可選件數
            addpriceArea.find('.js_addprice_tips .red').text(mainProduct.qty);

            addpriceArea.show();
            addpriceArea.addClass("fixed");

            refreshRetailAddPriceQuantity(addpriceArea.find('.js_addproduct_items'), getRetailAddPricePurchaseConditionByStandardId(mainProduct.standardId), mainProduct.qty);
        },

        // 查看商品詳細資料
        'showProductDetailLightbox': function (element, event) {
            var jqElem = $(element);
            var productId = jqElem.data('product-id');
            var standardId = jqElem.data('add-price-standard-id');
            var addpriceCheckbox = jqElem.closest('li').find('.js_add_cart_addprice[data-add-price-standard-id=' + standardId + ']');
            var isSoldOut = false;

            if (jqElem.data("is-sold-out") === 1){
                isSoldOut = true;
            }

            event.preventDefault();

            $.confirm({
                template: JconfirmTemplateHelper.getTemplate({
                    'templateType': '01',
                    'theme': 'el_confirm el_popup_view_product'
                }),
                columnClass: 'col-md-10',
                closeIcon: false,
                icon: '',
                title: false,
                content: 'URL:' + addprice_detail_url + '/' + productId + '/' + standardId,
                draggable: false,
                offsetTop: 40,
                offsetBottom: 40,
                buttons: {
                    confirmButton: {
                        keys: ['enter'],
                        text: '<span class="el_text_inner">'+ Lang.get('frontend.product.addPrice.detail.btn.confirm') + '</span>',
                        btnClass: 'js_confirm btn_add_price btn el_btn md solid el_rounded el_text m-0',
                        action: function () {
                            if (addpriceCheckbox.length > 0 && !addpriceCheckbox.prop("checked")) {
                                addpriceCheckbox.trigger('click');
                            }
                        }
                    },
                    cancelButton: {
                        keys: ['esc'],
                        text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.close') + '</span>',
                        btnClass: 'js_cancel btn_cancel btn el_btn md solid el_rounded el_text m-0',
                    }
                },
                onOpenBefore: function(){
                    this.$el.find('.js_confirm').attr('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                    this.$el.find('.js_confirm').data('style', JS_VARS_THEME_STYLE.mainButtonStyle);
                    this.$el.find('.js_confirm').data('hover-style', JS_VARS_THEME_STYLE.mainButtonHoverStyle);

                    this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                    this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                    this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

                    this.$el.find('.js_confirm, .btn_cancel').hover(
                        function () {
                            $(this).attr('style', $(this).data('hover-style'));
                        },
                        function () {
                            $(this).attr('style', $(this).data('style'));
                        }
                    );
                },
                contentLoaded: function(data, status, xhr){
                    if (data == 'error') {
                        returnMessageFromDialog(Lang.get('frontend.errormsg.addPrice.loadingerror'));
                        this.close();
                        return false;
                    } else {
                        this.setContent(data);
                        if (isSoldOut) {
                            this.$_confirmButton.hide();
                        }
                    }
                },
            });
            // 針對ios可能將focus放在<body>上捲動 +1 做修正
            $('.add_product_inner').scrollTop(1);
        }
    };

    $('#js_cart_detail_area').on('click', '.js_addpriceprudct_list_lightbox', function(e){
        let mainProduct = {
            'productId' : $(this).data('product-id'),
            'standardId' : $(this).data('standard-id'),
            'qty' : $(this).data('qty'),
        };
        let existAddprices = $(this).closest('.js_cart_item_list').find('.js_cart_list_del_add_price[data-standard-id=' + mainProduct.standardId + ']');
        e.preventDefault();
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_add_product'
            }),
            columnClass: 'col-md-10',
            closeIcon: false,
            icon: '',
            title: false,
            content: 'URL:' + addprice_list_url + '/' + mainProduct.productId,
            draggable: false,
            offsetTop: 0,
            offsetBottom: 0,
            buttons:false,
            onContentReady: function(data, status, xhr){
                const self = this;
                self.preOrderLimitConfig = JSON.parse(addpricePreOrderLimit).limit;

                self.preOrderAddpricePeriod = '';
                self.preOrderAddpriceList = [];
                self.addpriceQuantityElems  = self.$content.find('.js_addprice_quantity');
                self.addpriceCheckboxElems  = self.$content.find('.js_add_cart_addprice');
                self.addpriceProductLightboxElems  = self.$content.find('.js_addprice_lightbox');
                self.addpriceArea  = self.$content.find('.js_addprice_mobile_area');
                self.confirmButton  = self.$content.find('.js_btn_confirm');
                self.cancelButton  = self.$content.find('.js_btn_cancel');
                // 選擇數量
                self.addpriceQuantityElems.on('change', function(){
                    addPrice.changeQuantity(this);
                });

                // 加購勾選/取消
                self.addpriceCheckboxElems.on('click', function (e) {
                    const checkboxElem = $(this);
                    let checked = checkboxElem.prop('checked');

                    if (self.preOrderLimitConfig === '0') {
                        // 檢查商店是否開啟合併預購出貨月份訂單
                        if (!addPrice.preOrderMonthValidate(self.addpriceArea, checkboxElem)) {
                            checked = false;
                        }
                    }
                    addPrice.clickCheckbox(checkboxElem, checked);
                });

                // 檢視加購商品詳情
                self.addpriceProductLightboxElems.on('click', function(e){
                    addPrice.showProductDetailLightbox(this, e);
                });

                self.confirmButton.click(function(){
                    if (self.addpriceCheckboxElems.is(":checked") || existAddprices.length > 0) {
                        addCartItemAndPriceAction(mainProduct.qty, mainProduct.productId, mainProduct.standardId, self.addpriceArea);
                    }
                    self.close();
                });

                // cancel button
                self.cancelButton.click(function(){
                    self.close();
                });

                self.confirmButton.hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
                self.cancelButton.hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );

                addPrice.initView(existAddprices, self.addpriceArea, mainProduct);
            },
        });
        // 針對ios可能將focus放在<body>上捲動 +1 做修正
        $('.add_product_inner').scrollTop(1);
    });

});

var addCartItemAndPriceAction = function (qty, productId, standardId, addpriceArea) {
    var params = {
        product_id: productId,
        qty: qty,
        standard_id: standardId,
        removeItemAddprices: 'n',
        add_add_prices: {},
    };
    $.extend(params, getParams());

    if (params.standard_id <= 0) {
        returnMessageFromDialog(Lang.get('frontend.product.title.plz.selectstyle'));
        return;
    }

    var total_qty = 0,
        i = 0;
    var checkboxElems = addpriceArea.find('.js_add_cart_addprice');
    if (checkboxElems.length > 0) {
        params['removeItemAddprices'] = 'y';
        checkboxElems.each(function () {
            var check_val = $(this).prop('checked'),
                add_price_id = $(this).attr('data-add-price-id'),
                add_price_standard_id = $(this).attr('data-add-price-standard-id'),
                qty = $(this).closest('li').find('.js_addprice_quantity[data-add-price-id=' + add_price_id + '][data-add-price-standard-id=' + add_price_standard_id + ']').val();

            if (check_val) {
                total_qty += parseInt(qty);

                params['add_add_prices'][i] = {id: add_price_id,
                    standard_id: add_price_standard_id,
                    quantity: qty,
                    qty: qty,
                };
                i++;
            }
        });
    }


    if (checkRetailAddPriceQuantity(standardId, qty,params['add_add_prices'])) {
        const action = 'add_cart_item_and_add_price_item_batch';
        setCartItem(action, params, function(data) {
            if (typeof data != 'undefined' && typeof data.status != 'undefined' && data.status) {
                if (total_qty > 0) {
                    returnMessageFromDialog(Lang.get('frontend.product.addcart.success'));
                } else {
                    returnMessageFromDialog(Lang.get('frontend.product.remove.addPrice.success'));
                }
            }

            if (data.status) {
                recordAddOnAddToCartTrack(checkoutPageAddPriceItemAddToCart, action, params);
            }
            shippingCostDisplay(data);
        });
    }

    function recordAddOnAddToCartTrack(eventName, action, cartPrams)
    {
        let trackParams = {
            'parent_product_id': Number(cartPrams.product_id),
            'parent_standard_id': Number(cartPrams.standard_id),
            'add_on': []
        };
        Object.values(cartPrams.add_add_prices).forEach((value) => {
            if (parseInt(value.quantity) > 0) {
                trackParams.add_on.push({
                    'product_id': Number(value.id),
                    'standard_id': Number(value.standard_id),
                    'quantity': Number(value.quantity),
                });
            }
        });
        recordUserEventTrack(eventName, getCartAjaxUrl(action), trackParams);
    }
}

function checkRetailAddPriceQuantity(standardId, mainItemQuantity, addPricesList)
{
    const addPriceCondition = getRetailAddPricePurchaseConditionByStandardId(standardId);
    const addPriceItems = AddPriceFactory.buildAddPriceItemList(addPricesList);
    const check = checkAddPriceQuantity(mainItemQuantity, addPriceItems, addPriceCondition);

    if (! check.status) {
        new DialogMessage({
            'title': check.errorMessage,
        }).handle();
    }

    return check.status;
}

function getRetailAddPricePurchaseConditionByStandardId(standardId)
{
    const condition = $('.js_cart_item_list[data-standard-id="'+standardId+'"]').find('.js_retail_addprice_purchase_condition').val();
    const maxLimit = $('.js_cart_item_list[data-standard-id="'+standardId+'"]').find('.js_retail_addprice_purchase_condition_maxlimit').val();
    return AddPriceFactory.buildAddPriceConditions(condition, maxLimit);
}
